import { ReactElement, useState } from 'react';
import { Stack } from '@mui/material';
import {
  DateFromFilter,
  DateToFilter,
  GranularityFilter,
  PeriodFilter,
} from '../../../../Components/ReportsWidget/Filters';
import ReportWidget from '../../../../Components/ReportsWidget/Widget';
import type { ReportGranularity } from '../../../../Components/ReportsWidget/utils';
import type { ClicksSummariesResource } from '../../../../Entities/ClicksSummary';
import {
  defaultClicksSummaryChartZoomState,
  type ClicksSummaryChartZoomState,
} from './ClicksSummaryChart';
import ClicksSummaryDataTable from './ClicksSummaryDataTable';
import ExportButton from './ExportButton';
import PreviewButton from './PreviewButton';

export default function ClicksSummaryWidget(): ReactElement {
  const [hasPreview, setHasPreview] = useState(false);
  const [records, setRecords] = useState<ClicksSummariesResource[]>([]);
  const [isPending, setIsPending] = useState(false);
  const [granularity, setGranularity] = useState<ReportGranularity>('daily');
  const [chartZoomState, setChartZoomState] = useState<ClicksSummaryChartZoomState>(
    defaultClicksSummaryChartZoomState,
  );

  return (
    <Stack spacing={1}>
      <ReportWidget
        resource="clicks_summaries"
        filters={[PeriodFilter, GranularityFilter, DateFromFilter, DateToFilter]}
        defaultValues={{ period: 'last_30_days', granularity: 'daily' }}
        actions={
          <>
            <PreviewButton
              autoPreviewOnMount
              onPreviewStart={(granularity) => {
                setGranularity(granularity);
                setChartZoomState({ ...defaultClicksSummaryChartZoomState });
                setRecords([]);
                setHasPreview(true);
                setIsPending(true);
              }}
              onPreviewSuccess={(records) => {
                setRecords(records);
                setIsPending(false);
              }}
              onPreviewError={() => {
                setIsPending(false);
              }}
            />
            <ExportButton />
          </>
        }
      />
      {hasPreview && (
        <ClicksSummaryDataTable
          data={records}
          granularity={granularity}
          isPending={isPending}
          onZoomStateChange={setChartZoomState}
          zoomState={chartZoomState}
        />
      )}
    </Stack>
  );
}
